import React, { useState, useEffect, useMemo } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import * as XLSX from "xlsx";
import Select from "react-select";
import { toastError, toastSuccess } from "../../../../src/common/Toast";
import {
  DATA_EXPORT,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../src/common/Constant";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import { checkUserPermission } from "../../../common/UserPermission";
import MarkInactiveConfirmationModal from "../../../components/Modal/MarkInactive";
import moment from "moment";
import jsPDF from "jspdf";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Column from "antd/es/table/Column";
import CommonMatrialReactTableServerSideRender from "../../../components/Datatable/CommonMatrialReactTableServerSideRender";
import { DeleteIcon } from "../../../common/imagePath";
import { handleSaveColumnOrder } from "../../../common/common";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-account";
let PERMISSION_EDIT = "/manage-account/:id";
let PERMISSION_DELETE = "delete-accounts";
let PERMISSION_CHARTOFACCOUNT = "/chartofaccounttype-list";
let PERMISSION_ACCOUNTYPE = "/accounttype-list";
let PERMISSION_ACCOUNTYPEDETAILS = "/accounttypedetlis-list";
let PERMISSION_MARKINACTIVE = "/mark-inactive";
const ChartOfAccount = (props) => {
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  let selectData = [];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const loginuserid = localStorage.getItem("ID");
  const [syncdate, setsyncdate] = useState("");
  const [syncdates, setsyncdates] = useState("");
  console.log(deleteModal, "78787");
  const [perPage, setPerPage] = useState(25);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortingId, setSortingId] = useState(4);
  const [pencil, setPencil] = useState(false);
  const [filteredcolumns, setFilteredColumns] = useState([]);
  const [editdata, setEditData] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);

  //navigate

  const navigate = useNavigate();

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const chartaccountdropdown = [
    { label: "All", value: 0 },
    { label: "Created by you", value: 1 },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [selectedoptions, setSelectedOptions] = useState(0);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_File.xlsx`);
  };

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate,
    createdby
  ) => {
    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    console.log(
      JSON.stringify(
        columnFilters.map((el) => {
          return { columnname: el.id, value: el.value };
        })
      ) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      sorting[0]?.id,
      columnIndex,
      sorting[0]?.desc + " sorting | ",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    setLoading(true);
    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/accountselectall?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&startdate=${startingdate}&enddate=${endingdate}&createdby=${createdby}&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res , "1230000")
        setData(res.data.ResponseData.data);
        // setDeleteModal(false)
        console.log("HHELLO", res.data.ResponseData.syncdate);
        setRowCount(res.data.ResponseData.data[0]?.TotalRecord);
        setsyncdate(res.data.ResponseData.syncdate[0]?.SyncedDate);

        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleSelectChange = (
    e,
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate,
    createdby
  ) => {
    console.log(e, "event");
    setSelectedOptions(e.value);
    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/accountselectall?pagenumber=${pagenumber}&pagesize=${pagesize}&filtertext=${filtertext}&ordercolumn=${ordercolumn}&currentorder=${currentorder}&startdate=${startingdate}&enddate=${endingdate}&createdby=${
          e.value == 1 ? 0 : createdby
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData.data);
        console.log("11111");
        console.log(res.data.ResponseData.data, "123456");
        setRowCount(res.data.ResponseData[1][0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };

  const handleRowSelected = (e) => {
    // console.log(e,"event")
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.Id));
      selectData[currentPage] = e.selectedRows.map((x) => x.Id);
      console.log(selectData, "selectData");
      const selectedDataDeleteData =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      // console.log(selectedDataDeleteData,"selectedDataDelete")
      setSelectedDataDelete(selectedDataDeleteData);
    }
  };

  const handleDeletePopup = (id, quickbookid, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    let length;
    let quickbookids;
    let rowdata = [];
    if (field == "multipleRowInactive") {
      data = rows.map((el) => el.original.Id).join(",");
      length = rows.map((el) => el.original.Id).length;
      quickbookids = rows.map((el) => el.original.QuickbookId).join(",");
      rowdata = rows.map((el) => {
        return {
          quickbookid: el.original.QuickbookId,
          // type: el.original.ReceivingTypeId
        };
      });
    } else {
      data = id;
      length = 1;
      quickbookids = quickbookid;
      const obj = {
        quickbookid: quickbookid, // type: receivingtypeid
      };
      rowdata.push(obj);
    }
    console.log(data, "data245");

    // const deleteRequestParam = {
    //   accountids: pID || dd,
    // };
    // const deleteRequestParam = {
    //   accountids: selectedDataDelete,
    // };
    // console.log(deleteRequestParam,"deleteRequestparams" )
    const deleteRequestParam = {
      chartofaccountids: data,
      loginuserid: loginuserid,
      // locationid: location,
      quickbookarray: rowdata,
    };

    localStorage.setItem(
      "InactiveRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    localStorage.setItem("InactiveRequestParamlength", JSON.stringify(length));

    setDeleteModalOpen(true);
  };

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "Id",
      size: 120,
      Cell: checkUserPermission(PERMISSION_EDIT)
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() => navigate(`/manage-account/${row.original.Id}`)}
            >
              {row.original.Id}
            </Box>
          )
        : null,
      filterFn: "contains",
    },
    {
      header: "View Register",
      Cell: ({ row }) => {
        // return row.original.AccountType === "Accounts Receivable" ||
        //   row.original.AccountType === "Accounts Payable" ? (
        //   <button
        //     style={{ border: "1px solid", fontSize: "12px" }}
        //     className="btn btn-sm btn-outline-dark custom-bg-dark-button-color"
        //     onClick={() => navigate(`/account-report/${row.original.Id}`)}
        //   >
        //     View Register
        //   </button>
        // ) : (
        return (
          <button
            style={{ border: "1px solid", fontSize: "12px" }}
            className="btn btn-sm btn-outline-dark custom-bg-dark-button-color"
            onClick={() =>
              navigate(
                `/${
                  row.original.IsViewRegister > 0
                    ? `vregister`
                    : `account-report`
                }/${row.original.Id}`
              )
            }
          >
            {row.original.IsViewRegister > 0 ? "View Register" : "Run Report"}
          </button>
        );
        // );
      },
      size: 130,
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Account Type",
      accessorKey: "AccountType",
      size: 120,
    },
    {
      header: "Account Detail Type",
      accessorKey: "AccountDetailType",
    },
    {
      header: "CreatedDate",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("MM/DD/YYYY h:mm A"),
      size: 160,
    },
    {
      header: "SyncDate",
      accessorKey: "SyncDate",
      Cell: ({ row }) =>
        moment(row.original.SyncDate).format("MM/DD/YYYY h:mm A"),
      size: 160,
    },
    {
      header: "Quickbook SyncStatus",
      accessorKey: "SyncStatus",
      size: 110,
      Cell: ({ row }) =>
        row.original.SyncStatus == "Completed" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatus}
          </Box>
        ) : row.original.SyncStatus == "Failed" ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatus}
          </Box>
        ) : (
          ""
        ),
    },
    {
      header: "Balance",
      accessorKey: "Amount",
      Cell: ({ row }) =>
        row.original.IsViewRegister > 0 ? row.original.Amount : "",
      size: 120,
    },
  ]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      selectedoptions == 1 || selectedoptions == 0 ? 0 : 1
    );
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    handleListData(
      page,
      newPerPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      selectedoptions == 1 || selectedoptions == 0 ? 0 : 1
    );
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPage,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate,
      selectedoptions == 1 || selectedoptions == 0 ? 0 : 1
    );
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(
      1,
      perPage,
      e.target.value,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      selectedoptions == 1 || selectedoptions == 0 ? 0 : 1
    );
  };

  const handleChangeCustomStartingDate = (event) => {
    // console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const contextActions = useMemo(() => {
    return checkUserPermission("mark-inactive") ? (
      <div className="row px-2">
        <button
          type="button"
          className="btn btn-danger btn-sm pull-left "
          data-bs-toggle="modal"
          data-bs-target="#MarkInactiveConfirmationModal"
          onClick={handleDeletePopup}
        >
          <i className="fa fa-trash fa-sm" /> Mark Inactive
        </button>
      </div>
    ) : (
      " "
    );
  }, [data, selectedRows]);

  const handleQuickBookChange = (fieldName, event) => {
    // console.log("Value ==> ", event);
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      var currentDateForLastWeek = new Date();
      // console.log("currentDateForLastWeek ==> ", currentDateForLastWeek);
      // Set the date to the start of the current week (Sunday)
      var startOfWeekForLastWeek = new Date(
        currentDateForLastWeek.setDate(
          currentDateForLastWeek.getDate() - currentDateForLastWeek.getDay()
        )
      );
      // console.log("startOfWeekForLastWeek ==> ", startOfWeekForLastWeek);

      // Set the date to the end of the last week (Saturday)
      var endOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(startOfWeekForLastWeek.getDate() - 1)
      );
      // console.log("endOfLastWeekForLastWeek ==> ", endOfLastWeekForLastWeek);

      // Set the date to the start of the last week (Sunday)
      var startOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(endOfLastWeekForLastWeek.getDate() - 6)
      );

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForLastWeek = startOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      var endDateStringForLastWeek = endOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      // Output the results
      // console.log(
      //   "Last week started on " +
      //     startDateStringForLastWeek +
      //     " and ended on " +
      //     endDateStringForLastWeek
      // );
      setStartingDate(startDateStringForLastWeek);
      setEndingDate(endDateStringForLastWeek);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      var currentDateForCurrentWeek = new Date();
      // console.log("currentDateForCurrentWeek ==> ", currentDateForCurrentWeek);

      // Set the date to the start of the current week (Sunday)
      var startOfWeekForCurrentWeek = new Date(
        currentDateForCurrentWeek.getTime() -
          currentDateForCurrentWeek.getDay() * 24 * 60 * 60 * 1000
      );
      // console.log("startOfWeekForCurrentWeek ==> ", startOfWeekForCurrentWeek);

      // Set the date to the end of the current week (Saturday)
      var endOfWeekForCurrentWeek = new Date(
        startOfWeekForCurrentWeek.getTime() + 6 * 24 * 60 * 60 * 1000
      );
      // console.log("endOfWeekForCurrentWeek ==> ", endOfWeekForCurrentWeek);

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForCurrentWeek = startOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      var endDateStringForCurrentWeek = endOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   "Current week started on " +
      //     startDateStringForCurrentWeek +
      //     " and ended on " +
      //     endDateStringForCurrentWeek
      // );

      setStartingDate(startDateStringForCurrentWeek);
      setEndingDate(endDateStringForCurrentWeek);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      // Get today's date
      const todayForLastMonth = new Date();

      // Get the first day of the current month
      const firstDayCurrentMonthForLastMonth = new Date(
        todayForLastMonth.getFullYear(),
        todayForLastMonth.getMonth(),
        1
      );

      // Get the last day of the previous month
      const lastDayPrevMonthForLastMonth = new Date(
        firstDayCurrentMonthForLastMonth.getTime() - 1
      );

      // Get the starting date of the previous month
      const firstDayPrevMonthForLastMonth = new Date(
        lastDayPrevMonthForLastMonth.getFullYear(),
        lastDayPrevMonthForLastMonth.getMonth(),
        1
      );

      // Format the starting and ending dates of the previous month as yyyy-mm-dd
      const startDateFormattedForLastMonth = firstDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForLastMonth = lastDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of last month: ${startDateFormattedForLastMonth}`
      // );
      // console.log(`Ending date of last month: ${endDateFormattedForLastMonth}`);
      setStartingDate(startDateFormattedForLastMonth);
      setEndingDate(endDateFormattedForLastMonth);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      // Get today's date
      const todayForCurrentMonth = new Date();

      // Get the first day of the current month
      const firstDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth(),
        1
      );

      // Get the last day of the current month
      const lastDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth() + 1,
        0
      );

      // Format the starting and ending dates of the current month as yyyy-mm-dd
      const startDateFormattedForCurrentMonth = firstDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForCurrentMonth = lastDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of current month: ${startDateFormattedForCurrentMonth}`
      // );
      // console.log(
      //   `Ending date of current month: ${endDateFormattedForCurrentMonth}`
      // );
      setStartingDate(startDateFormattedForCurrentMonth);
      setEndingDate(endDateFormattedForCurrentMonth);
    }
  };

  const handleQuickBookDownload = () => {
    if (
      quickBookOptions.value == undefined ||
      quickBookOptions.value == null ||
      quickBookOptions.value == ""
    ) {
    } else if (
      (startingDate === undefined || endingDate === undefined) &&
      quickBookOptions.value == 1
    ) {
      setStartingDate("");
      setEndingDate("");
    } else if (
      (startingDate === undefined || endingDate === undefined) &&
      quickBookOptions.value == 2
    ) {
      // console.log("Undefined dates");
    } else {
      axios
        .get(
          `${
            config.accountingBaseUrl
          }/chartofaccounts/excelexportlisting?filtertext=${""}&startdate=${startingDate}&enddate=${endingDate}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // console.log("res ==> ", res.data.ResponseData);

          const data =
            res.data.ResponseData.length > 0
              ? res.data.ResponseData
              : [
                  {
                    [`ID`]: null,
                    [`Account Name`]: null,
                    [`Type`]: null,
                    [`Detail Type`]: null,
                    [`Created Date`]: null,
                  },
                ];

          // Create a new workbook
          const workbook = XLSX.utils.book_new();

          // Convert the data to a worksheet
          const worksheet = XLSX.utils.json_to_sheet(data);

          // Add the worksheet to the workbook
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          // Save the workbook as an Excel file
          XLSX.writeFile(
            workbook,
            `account_quickbook_${startingDate}_${endingDate}.xlsx`
          );
          setLoading(false);
        })
        .catch((err) => {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        });
    }
  };

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  useEffect(() => {
    handleListData(
      1,
      perPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      0
    );
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    columnFilters,
    deleteModal,
  ]);

  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }

  // useEffect(() => {
  //   setFilteredColumns(columns.filter(
  //     (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  //   ))
  // }, [hiddenColumns])

  const handleCancel = () => {
    // filteredColumns=columns
    setFilteredColumns(columns);
    setPencil(false);
  };

  const handleSearch = (e, id) => {
    let obj = { ID: id, Name: e.target.value };
    setEditData((prevEditData) => [...prevEditData, obj]);
  };

  console.log(editdata, "editdata");

  const batchEdit = (columnName) => {
    const filteredIndex = columns.findIndex(
      (item) => item.accessorKey == columnName
    );
    console.log(filteredIndex, "filteredIndex");

    let obj = {
      header: "Name",
      accessorKey: "Name",
      enableEditing: true,
      Edit: ({ row }) => {
        return (
          <input
            type="search"
            placeholder="Search..."
            className="search-btn form-control form-control-sm "
            onChange={(e) => handleSearch(e, row.original.Id)}
            defaultValue={row.Name}
          />
        );
      },
    };

    // let obj = {
    //   name: "Name",
    //   selector: "Name",
    //   sortable: true,
    //   width: "300px",
    //   cell: (row) => (
    //     <input
    //       type="search"
    //       placeholder="Search..."
    //       className="search-btn form-control form-control-sm "
    //       onChange={(e) => handleSearch(e, row.Id)}
    //       defaultValue={row.Name}
    //     />
    //   ),
    // }

    const updateddata = [...columns];

    updateddata[filteredIndex] = obj;

    setFilteredColumns(updateddata);
    // filteredColumns=updateddata;
    // filteredColumns=[{...columns, columns[filteredIndex]: }]
  };

  // console.log(filteredColumns,"filteredColumns")

  const handlePrint = () => {
    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 0;
    let endIndex = 27;

    // Loop through the customerList array

    for (var i = 0; i < Math.ceil(data.length / 28); i++) {
      // Printing header-
      if (i == 0) {
        content +=
          '<div style="width: 560px; text-align: center; font-weight: bold"><p style="font-size: 10px; margin: 1rem;">Chart of Accounts</p></div>';
      } else {
        content +=
          '<div style="width: 560px; text-align: center; font-weight: bold; margin-top: 2.5rem"><p style="font-size: 10px; margin: 1rem;">Chart of Accounts</p></div>';
      }

      // Printing table body-

      content +=
        '<table style="font-size: 7px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">Sr No.</th>' +
        '<th style="padding: 8px;">Name</th>' +
        '<th style="padding: 8px;">Chart Of Account Type</th>' +
        '<th style="padding: 8px;">Account Type</th>' +
        '<th style="padding: 8px;">Account Detail Type</th>' +
        '<th style="padding: 8px;">Balance</th>' +
        // '<th style="padding: 8px;">Created On</th>' +

        "</tr></thead>";

      content += "<tbody>";

      // Loop for printing items based on endIndex-

      for (
        let index = startIndex;
        index < data.length && index <= endIndex;
        index++
      ) {
        content +=
          "<tr>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          (index + 1) +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          data[index].Name +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          data[index].ChartOfAccountType +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          data[index].AccountType +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          data[index].AccountDetailType +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          data[index].Amount +
          "</td>" +
          // '<td style="font-size: 7px; padding: 8px;">' +

          // "</td>" +

          "</tr>";
      }

      content += "</tbody>";

      content += "</table>";

      // Update startIndex and endIndex for the next iteration

      startIndex = endIndex + 1;

      endIndex = startIndex + 27;
    }

    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
      },
    });
  };

  const handleSave = () => {
    const jsondata = {};
    jsondata.accountxml = editdata;

    let jsonupdateddata = JSON.stringify(jsondata);
    setLoading(true);
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/accountbatchupdate`,
        {
          accountbatchupdatexml: jsonupdateddata,
          loginuserid: Id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          handleListData(
            1,
            perPage,
            searchtext,
            sortingId,
            sortingDirection,
            startingDate,
            endingDate,
            0
          );
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
        setFilteredColumns(columns);
        setPencil(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSync = () => {
    setLoading(true);
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/SyncAccountqb`,
        { loginuserid: loginuserid },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.ResponseID == 1) {
          toastSuccess(
            " we have sucessfully synced All COA from Quickbooks to  POS"
          );
        }

        if (res.data.ResponseID == 2) {
          toastError(res.data.ResponseMessage);
        }

        if (res.data.ResponseID == 3) {
          toastError(res.data.ResponseMessage);
        }

        if (res) {
          setLoading(true);
          axios
            .post(
              `${config.accountingBaseUrl}/chartofaccounts/depositAccountqb`,
              { loginuserid: loginuserid },
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  "Access-Control-Allow-Origin": "*",
                  Authorization: token,
                },
              }
            )
            .then((res) => {
              setLoading(false);
              setDeleteModal(true);
              // if (res.data.ResponseID == 1) {
              //   toastSuccess(
              //     " we have sucessfully synced All COA from Quickbooks to  POS"
              //   );
              // }

              // if (res.data.ResponseID == 2) {
              //   toastError(res.data.ResponseMessage);
              // }

              // if (res.data.ResponseID == 3) {
              //   toastError(res.data.ResponseMessage);
              // }
              // handle successful response
            })
            .catch((err) => {
              toastError("Failed to Sunc Data from Quickbook to POS");
              setLoading(false);
              // handle error
            });
        }
        // handle successful response
      })
      .catch((err) => {
        toastError("Failed to Sunc Data from Quickbook to POS");
        setLoading(false);
        // handle error
      });
  };

  useEffect(() => {
    if (!syncdate) {
      console.error("syncdate is undefined or invalid");
      return;
    }

    const formattedString = syncdate.replace(".000Z", ".00Z");
    console.log(formattedString, "111");

    const userTimezone = moment.tz.guess();
    console.log(`User's timezone: ${userTimezone}`, "111");

    const utcoffset = moment(formattedString).tz(userTimezone).utcOffset() / 60;
    console.log(`UTC offset: ${utcoffset} hours`, "111");

    let localTimestamp = moment(formattedString)
      .tz(userTimezone)
      .format("MM/DD/YYYY h:mm A");
    console.log(`Local timestamp: ${localTimestamp}`, "111");

    let final = moment(localTimestamp)
      .add(utcoffset, "h")
      .format("MM/DD/YYYY h:mm A");
    console.log(final, "111final");

    setsyncdates(localTimestamp);
  }, [syncdate]);

  const renderRowActionMenuItems = ({ row, table }) => [
    checkUserPermission("/manage-account/:id") ? (
      <MenuItem
        key="edit"
        onClick={() => navigate(`/manage-account/${row.original.Id}`)}
      >
        Edit
      </MenuItem>
    ) : null,
    checkUserPermission("mark-inactive") ? (
      <MenuItem
        key="delete"
        title="Delete"
        // data-bs-toggle="modal"
        // data-bs-target="#MarkInactiveConfirmationModal"
        onClick={() =>
          handleDeletePopup(
            row.original.Id,
            row.original.QuickbookId,
            "",
            "singleRowInactive"
          )
        }
      >
        Mark Inactive
      </MenuItem>
    ) : null,
    checkUserPermission("/account-report/:id") ? (
      <MenuItem
        key="edit"
        onClick={() => navigate(`/account-report/${row.original.Id}`)}
      >
        Run Report
      </MenuItem>
    ) : null,
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) &&
        (checkUserPermission("mark-inactive") ? (
          <Button
            // size="small"
            class="btn btn-sm btn-secondary"
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            //only export selected rows
            onClick={() =>
              handleDeletePopup(
                "",
                "",
                table.getSelectedRowModel().rows,
                "multipleRowInactive"
              )
            }
            // startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            Mark InActive
          </Button>
        ) : (
          " "
        ))}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h6 className="page-title">Accounting: Chart of Accounts</h6> */}
              <ul className="breadcrumb" style={{ marginLeft: "11px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Chart Accounts</li>
              </ul>
            </div>
          </div>
          <div className="d-flex">
            <div className="d-flex col-md-4">
              {/* <div className="col-md-4 ml-3">
                <input
                  type="search"
                  placeholder="Search..."
                  className="search-btn form-control form-control-sm w-100"
                  onChange={ChangeFilterText}
                  value={searchtext}
                />
              </div> */}
              <div className="col-md-8">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  defaultValue={selectedoptions}
                  onChange={(event) => {
                    handleListData(
                      1,
                      perPage,
                      searchtext,
                      sortingId,
                      sortingDirection,
                      startingDate,
                      endingDate,
                      event?.value > 0 ? Id : 0
                    );
                  }}
                  placeholder="All"
                  options={chartaccountdropdown}
                  // hideSelectedOptions={true}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  // isClearable={true}
                  id="ExcelExport"
                  name="ExcelExport"
                  className="ml-2 custom-search-select"
                />
              </div>
            </div>
            <div
              className="btn-group justify-content-end ms-2 dropdown col-md-8 "
              //  style={{width:"57%"}}
            >
              <p style={{ marginRight: "10px", marginTop: "20px" }}>
                {" "}
                Last Sync DateTime : {syncdates}
              </p>
              <div className="me-2">
                {checkUserPermission("export-button") ? (
                  <button
                    // className="btn btn-added pull-right"
                    className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                    style={{ width: "max-content" }}
                    onClick={() => onBtExport([], "AllData")}
                  >
                    <i
                      className="fa fa-download mr-2"
                      style={{ color: "#111930" }}
                    ></i>
                    Export Visible Column
                    {/* <i class="fa-thin fa-download"></i> */}
                  </button>
                ) : (
                  ""
                )}
              </div>

              <div
                className="cursor-pointer mt-1 mr-3"
                onClick={() =>
                  handleSaveColumnOrder(
                    loginuserid,
                    "Accounts",
                    columnOrder,
                    token,
                    columnVisibility
                  )
                }
                title="Lock Your Sequence"
                // onMouseEnter={() => setIcon(ColumnOrderIconHover)}
                // onMouseLeave={() => setIcon(ColumnOrderIcon)}
              >
                <i class="fa fa-lock columnsLock fs-4"></i>
              </div>

              <div className="me-2">
                {checkUserPermission(PERMISSION_ADD) ? (
                  <button
                    //to="/manage-account"
                    onClick={handleSync}
                    className="btn btn-primary  btn-sm pull-right"
                  >
                    <i
                      className="fa fa-plus me-2 lg"
                      style={{ color: "white" }}
                    ></i>
                    Sync COA from QB {/* //Add Account */}
                  </button>
                ) : (
                  ""
                )}
              </div>
              {checkUserPermission("/manage-inactive-account") && (
                <div className="btn-group-sm pull-right ms-2 custom-bg-dark-button-color">
                  <button
                    type="button"
                    className="btn btn-outline-dark d-none custom-bg-dark-button-color"
                  >
                    More
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-dark dropdown-toggle me-1 custom-bg-dark-button-color"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ borderRadius: "5px" }}
                  >
                    More &nbsp;
                  </button>
                  <div className="dropdown-menu">
                    {checkUserPermission("/manage-inactive-account") && (
                      <li>
                        <Link
                          class="dropdown-item"
                          to="/manage-inactive-account"
                        >
                          Manage Inactive Account
                        </Link>
                      </li>
                    )}
                    {checkUserPermission("print-account") && (
                      <li>
                        <div
                          className="dropdown-item"
                          // type="button"
                          // className="btn btn-outline-dark btn-sm custom-bg-dark-button-color"
                          // aria-haspopup="true"
                          // aria-expanded="false"
                          onClick={handlePrint}
                        >
                          <i
                            class="fa fa-print"
                            style={{ cursor: "pointer", marginRight: "5px" }}
                            aria-hidden="true"
                          ></i>
                          Print
                        </div>
                      </li>
                    )}
                  </div>
                </div>
              )}
              <div>
                {pencil ? (
                  <div className="d-flex">
                    <div className=" mb-3">
                      <button
                        className="btn btn-primary me-3 btn-sm"
                        onClick={handleSave}
                      >
                        Save
                      </button>
                      <button
                        onClick={handleCancel}
                        className="btn btn-secondary btn-sm"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-lg-12 col-md-6 col-sm-12">
              <div className="d-none flex-wrap">
                <div className="p-3 mt-3 col-lg-2 col-md-6 col-sm-12">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange("ExcelExport", event);
                    }}
                    options={options}
                    hideSelectedOptions={true}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    id="ExcelExport"
                    name="ExcelExport"
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="p-3 col-lg-2 col-md-6 col-sm-12">
                      Custom Start Date:
                      <input
                        type="date"
                        className="form-control"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                      />
                    </div>
                    <div className="p-3 col-lg-2 col-md-6 col-sm-12">
                      Custom End Date:
                      <input
                        type="date"
                        className="form-control"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                      />
                    </div>
                  </>
                )}
                <div className="p-3 col-lg-1 col-md-6 col-sm-12 mt-3">
                  <button
                    className="btn btn-dark"
                    onClick={() => handleSearchAccordingToDate()}
                  >
                    Search
                  </button>
                </div>
                <div className="p-3 col-lg-3 col-md-5 col-sm-12 mt-3">
                  <button
                    className="btn btn-primary"
                    onClick={() => handleQuickBookDownload()}
                  >
                    Export to excel for quickbook
                  </button>
                </div>
                {quickBookOptions?.value !== 2 && (
                  <>
                    <div className="p-3 col-lg-4 col-md-1 col-sm-12"></div>
                  </>
                )}
                <div className="p-3 col-lg-2 col-md-3 col-sm-12 mt-4">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="search-btn form-control form-control-sm w-100"
                    onChange={ChangeFilterText}
                    value={searchtext}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-12 col-md-6 col-sm-12">
              <div className="d-flex flex-wrap">
                {/* <div className="col-lg-2 col-md-6 col-sm-12">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="search-btn form-control form-control-sm w-100"
                    onChange={ChangeFilterText}
                    value={searchtext}

                  />
                </div> */}
                {/* <div className="mb-2 col-lg-2 col-md-6 col-sm-12 ">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                    defaultValue={selectedoptions}
                    onChange={(event) => {
                      handleSelectChange(event, 1,
                        perPage,
                        searchtext,
                        sortingId,
                        sortingDirection,
                        startingDate,
                        endingDate,
                        1)
                    }}
                    placeholder="All"
                    options={chartaccountdropdown}
                    // hideSelectedOptions={true}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    // isClearable={true}
                    id="ExcelExport"
                    name="ExcelExport"
                    className="ml-2 custom-search-select"
                  />
                </div> */}
                {/* <div className="col-lg-4 col-md-1 col-sm-12"></div> */}
                {/* {pencil ?
                  <div className=" col-lg-4 col-md-3 col-sm-12 mt-2  text-right">
                    <div className=" mb-3">
                      <button

                        className="btn btn-primary me-3 btn-sm"
                        onClick={handleSave}
                      >
                        Save
                      </button>
                      <button
                        onClick={handleCancel}
                        className="btn btn-secondary btn-sm"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                  :
                  <div className=" col-lg-4 col-md-3 col-sm-12 text-right">
                    <button
                      type="button"
                      className="btn btn-outline-dark btn-sm mr-2"

                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={() => { setPencil(true); batchEdit("Name") }}
                    >
                      <i class="fa fa-pencil" style={{ cursor: "pointer" }} aria-hidden="true"></i> Batch Edit &nbsp;
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-dark  btn-sm"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={handlePrint}
                    >
                      <i class="fa fa-print" style={{ cursor: "pointer", marginRight: "3px" }} aria-hidden="true"></i>
                      Print
                    </button>
                  </div>
                } */}
              </div>
            </div>
          </div>

          <CommonMatrialReactTableServerSideRender
            MainHeading="Sonar POS"
            ReportHeading="Account List"
            columns={columns}
            data={data}
            // startdate={startdate}
            // enddate={enddate}
            columnGrouping={[]}
            columnsVisibility={{}}
            enableRowActions={
              checkUserPermission("/manage-account/:id") ||
              checkUserPermission("mark-inactive") ||
              checkUserPermission("/account-report/:id")
            }
            enableRowSelection={true}
            renderRowActionMenuItems={renderRowActionMenuItems}
            renderTopToolbarCustomActions={renderTopToolbarCustomActions}
            density="comfortable"
            showGlobalFilter={true}
            showColumnFilters={false}
            expanded={true}
            pagination={{ pageIndex: 0, pageSize: 25 }}
            rowCount={rowCount}
            setColumnFilters={setColumnFilters} // for termp comment filteron column
            setGlobalFilter={setGlobalFilter}
            setPagination={setPagination}
            setSorting={setSorting}
            setColumnOrder={setColumnOrder}
            setColumnVisibility={setColumnVisibility} //setColumnVisibility
            state={{
              columnFilters, // for termp comment filteron column
              // globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
              columnOrder,
              columnVisibility,
            }}
          />
        </div>
      </div>
      {/* <DeleteConfirmationModal
        deleteApiUrl={`${config.accountingBaseUrl}/chartofaccounts/accountdelete`}
      /> */}

      <MarkInactiveConfirmationModal
        InactiveApiUrl={`${config.accountingBaseUrl}/chartofaccounts/accountinactive`}
        // rows={selectedRows.length}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default ChartOfAccount;
